import {forwardRef} from "react";
import {Button, ButtonProps} from "@chakra-ui/react";

export type MainButtonProps = ButtonProps & {
    variantStyle?: "default" | "subscribe" | "subscribed" | "subscribe2";
};

/**
 * Основная стилизованная кнопка, поддерживает варианты subscribe/subscribed.
 * forwardRef нужен для корректного позиционирования Chakra Menu / Popover при as={MainButton}.
 */
export const MainButton = forwardRef<HTMLButtonElement, MainButtonProps>(
    ({variantStyle = "default", ...props}, ref) => {
        const baseStyle: ButtonProps = {
            height: "28px",
            fontSize: "14px",
            fontFamily: "Poppins",
            borderRadius: "5px",
            border: "1px",
            borderColor: "gray.200",
        };

        let variantStyleProps: ButtonProps;

        switch (variantStyle) {
            case "subscribed":
                variantStyleProps = {
                    background: "#e7e1d2", // более насыщенный бежевый
                    color: "blackAlpha.800",
                    fontWeight: "sm",
                    _hover: {background: "#dbd4c3", cursor: "pointer"},
                    _active: {background: "#d0c8b6"},
                };
                break;
            case "subscribe":
                variantStyleProps = {
                    background: "#ffd814", // ярко-жёлтый как у Amazon "Subscribe"
                    color: "black",
                    _hover: {background: "#f7ca00", cursor: "pointer"},
                    _active: {background: "#e6b800"},
                };
                break;
            case "subscribe2":
                variantStyleProps = {
                    background: "#f0f2f2", // ярко-жёлтый как у Amazon "Subscribe"
                    color: "#565959",
                    fontWeight: "sm",
                    _hover: {background: "#f0f2f2", cursor: "pointer"},
                    _active: {background: "#f0f2f2"},
                };
                break;
            case "default":
            default:
                variantStyleProps = {
                    bg: "primary.gray.light",
                    color: "black",
                };
                break;
        }

        return <Button ref={ref} {...baseStyle} {...variantStyleProps} {...props} />;
    },
);

MainButton.displayName = "MainButton";
